import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Visibility = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25 9.375C20.053 9.37788 15.2215 10.8698 11.1341 13.6566C7.04681 16.4434 3.89299 20.396 2.08313 25C3.89057 29.6056 7.04377 33.5597 11.1316 36.3468C15.2194 39.1339 20.0522 40.6246 24.9997 40.6246C29.9472 40.6246 34.78 39.1339 38.8678 36.3468C42.9556 33.5597 46.1088 29.6056 47.9163 25C46.1064 20.3961 42.9527 16.4435 38.8655 13.6568C34.7783 10.87 29.9469 9.378 25 9.375ZM25 35.4169C22.9397 35.417 20.9257 34.8062 19.2125 33.6616C17.4994 32.5171 16.1641 30.8902 15.3756 28.9868C14.5871 27.0834 14.3807 24.9889 14.7826 22.9682C15.1845 20.9474 16.1765 19.0913 17.6333 17.6344C19.0901 16.1775 20.9462 15.1853 22.9669 14.7833C24.9876 14.3813 27.0821 14.5876 28.9856 15.376C30.8891 16.1644 32.516 17.4996 33.6607 19.2126C34.8053 20.9257 35.4163 22.9397 35.4163 25C35.4153 27.7623 34.3175 30.4112 32.3643 32.3645C30.4112 34.3178 27.7623 35.4157 25 35.4169ZM25 18.75C23.7639 18.75 22.5555 19.1166 21.5277 19.8033C20.4999 20.4901 19.6988 21.4662 19.2258 22.6082C18.7527 23.7503 18.6289 25.0069 18.8701 26.2193C19.1113 27.4317 19.7065 28.5453 20.5806 29.4194C21.4547 30.2935 22.5683 30.8888 23.7807 31.1299C24.9931 31.3711 26.2497 31.2473 27.3918 30.7742C28.5338 30.3012 29.5099 29.5001 30.1967 28.4723C30.8834 27.4445 31.25 26.2361 31.25 25C31.2511 24.1789 31.0901 23.3657 30.7764 22.607C30.4627 21.8482 30.0024 21.1588 29.4218 20.5782C28.8412 19.9976 28.1518 19.5373 27.393 19.2236C26.6343 18.9099 25.8211 18.7489 25 18.75Z"
        fill={color}
      />
    </svg>
  )
}
